<h2 mat-dialog-title>Select Product</h2>

<div mat-dialog-content class="product-select-dialog__content">
  <div class="product-select-dialog__header">
    <div class="product-select-dialog__info">
      <span class="product-select-dialog__label">Vendor:</span>
      <span class="product-select-dialog__value">{{ data?.vendorDomain }}</span>
    </div>
    <div class="product-select-dialog__info" *ngIf="data?.productName">
      <span class="product-select-dialog__label">Product filter:</span>
      <span class="product-select-dialog__value">{{ data?.productName }}</span>
    </div>
  </div>

  <div class="product-select-dialog__table-container" *ngIf="!loading; else loadingState">
    

    <ng-container *ngIf="dataSource.length; else emptyState">
      <div class="product-select-dialog__table-wrapper">
        <table mat-table [dataSource]="dataSource" class="product-select-dialog__table" [trackBy]="trackById">

          <ng-container matColumnDef="select">
            <th class="bg-light" mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let element">
              <mat-radio-button
                [checked]="element.id === selectedProductId"
                (click)="$event.stopPropagation(); onRowClick(element)">
              </mat-radio-button>
            </td>
          </ng-container>

          <ng-container matColumnDef="name">
            <th class="bg-light" mat-header-cell *matHeaderCellDef> Name </th>
            <td mat-cell *matCellDef="let element" (click)="onRowClick(element)" class="text-truncate">
              {{ element.name || '—' }}
            </td>
          </ng-container>

          <ng-container matColumnDef="category">
            <th class="bg-light" mat-header-cell *matHeaderCellDef> Category </th>
            <td mat-cell *matCellDef="let element" (click)="onRowClick(element)" class="text-truncate">
              {{ element.category || '—' }}
            </td>
          </ng-container>

          <ng-container matColumnDef="avgRating">
            <th class="bg-light" mat-header-cell *matHeaderCellDef> Avg</th>
            <td mat-cell *matCellDef="let element" (click)="onRowClick(element)">
              {{ element.avgRating != null ? (element.avgRating | number: '1.1-2') : '—' }}
            </td>
          </ng-container>

          <ng-container matColumnDef="reviewCount">
            <th class="bg-light" mat-header-cell *matHeaderCellDef> Reviews </th>
            <td mat-cell *matCellDef="let element" (click)="onRowClick(element)">
              {{ element.reviewCount != null ? element.reviewCount : '—' }}
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr
            mat-row
            *matRowDef="let row; columns: displayedColumns"
            (click)="onRowClick(row)"
            [class.product-select-dialog__row--selected]="row.id === selectedProductId">
          </tr>
        </table>
      </div>
    </ng-container>
    <mat-paginator
      class="product-select-dialog__paginator bg-light"
      [length]="totalElements"
      [pageSize]="pageSize"
      [pageIndex]="pageIndex"
      [pageSizeOptions]="[5, 10, 20, 50]"
      (page)="onPageChange($event)">
    </mat-paginator>
  </div>

  <ng-template #emptyState>
    <div class="product-select-dialog__empty">
      No products found.
    </div>
  </ng-template>

  <ng-template #loadingState>
    <div class="product-select-dialog__loading">
      <mat-progress-spinner mode="indeterminate" diameter="40"></mat-progress-spinner>
      <span>Loading products…</span>
    </div>
  </ng-template>
</div>

<div mat-dialog-actions align="end">
  <button mat-button type="button" (click)="onCancel()">Cancel</button>
  <button mat-flat-button color="primary" type="button" (click)="onSelect()" [disabled]="!selectedProductId">
    Select
  </button>
</div>
